document.addEventListener("DOMContentLoaded", (e) => {
  document.querySelectorAll("button[data-slider]").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      document
        .getElementById(e.currentTarget.dataset.slider)
        ?.classList.remove("hidden");
      document
        .querySelector(".industry-images__main")
        .classList.remove("visibly-hidden");
      document
        .querySelector(".grfq-quote-widget-container")
        .classList.add("slider-active");
      document.querySelector("html").style.overflow = "hidden";
      window.dispatchEvent(new Event("resize"));
      window.dispatchEvent(new Event("resize"));
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 1);
    });
    btn.addEventListener("mouseenter", loadImages);
    btn.addEventListener("touchstart", loadImages);
    function loadImages(e) {
      if (document.getElementById(e.currentTarget.dataset.slider)) {
        document
          .getElementById(e.currentTarget.dataset.slider)
          .querySelectorAll("img")
          .forEach((img, i, arr) => {
            if (window.innerWidth < 768) {
              if (i == 0 || i == 1 || i == arr.length - 1) {
                console.log(img);
                if (img.dataset.src) {
                  img.src = img.dataset.src;
                  img.removeAttribute("data-src");
                }
                console.log(img);
              }
              if (i == 0) {
                img.addEventListener("load", (e) => {
                  window.dispatchEvent(new Event("resize"));
                });
              }
            } else {
              if (i == 0 || i == 1 || i == 2 || i == arr.length - 1) {
                if (img.dataset.src) {
                  img.src = img.dataset.src;
                  img.removeAttribute("data-src");
                }
              }
              if (i == 0) {
                img.addEventListener("load", (e) => {
                  window.dispatchEvent(new Event("resize"));
                });
              }
            }
          });
      }
    }
  });
});
